import React, { useState } from 'react';
import { Box, Typography, Button } from '@mui/material';
import { Slideshow as SlideshowIcon } from '@mui/icons-material';
import FullUserFeed from '../components/Social/FullUserFeed';
import FeedErrorBoundary from '../components/ErrorBoundary/FeedErrorBoundary';
import FashionShowReel from '../components/FashionShow/FashionShowReel';

/**
 * Feed page with comprehensive error handling
 * Prevents React error #185 from affecting the entire app
 *
 * Includes Fashion Show Reel entry point (Requirements: 1.1, 1.2)
 */
const FeedPage: React.FC = () => {
  const [showFashionReel, setShowFashionReel] = useState(false);

  if (showFashionReel) {
    return (
      <Box sx={{ py: 3, width: '100%' }}>
        <FashionShowReel onClose={() => setShowFashionReel(false)} />
      </Box>
    );
  }

  return (
    <Box sx={{ py: 3, width: '100%' }}>
      <Box sx={{ mb: 3, display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' }}>
        <Box>
          <Typography variant="h4" component="h1" gutterBottom>
            Fashion Feed
          </Typography>
          <Typography variant="body1" color="text.secondary">
            Discover the latest fashion trends and outfits from the community
          </Typography>
        </Box>
        <Button
          variant="contained"
          color="secondary"
          startIcon={<SlideshowIcon />}
          onClick={() => setShowFashionReel(true)}
          sx={{ whiteSpace: 'nowrap', mt: 0.5 }}
        >
          Fashion Show
        </Button>
      </Box>

      <FeedErrorBoundary>
        <FullUserFeed 
          showTabs={true}
          showFilters={true}
          maxItems={50}
        />
      </FeedErrorBoundary>
    </Box>
  );
};

export default FeedPage;
